



















































import Axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CarouselTireImage extends Vue {
  @Prop()
  private images!: string[];
  @Prop()
  private tireIndex!: number;
  @Prop()
  private isSummer!: boolean;
  @Prop()
  private showDeleteImage!: boolean;
  @Prop()
  private imageScratchIndex!: number;
  @Prop()
  private showImg!: boolean;

  private scratchIndex: number = 0;

  private imageIndex: number = 0;

  private created() {
    this.scratchIndex = this.imageScratchIndex;
  }

  get nextDisabledState() {
    return this.images.length === (this.imageIndex + 1);
  }
  get preDisabledState() {
    return this.imageIndex === 0;
  }

  public chooseImage() {
    this.$emit("selectedImage", this.imageIndex, this.tireIndex, this.isSummer);
  }

  public onClickImage() {
    this.$emit("imageClick", this.imageIndex, this.tireIndex, this.isSummer);
  }

  private nextImage() {
    this.imageIndex++;
  }
  private preImage() {
    this.imageIndex--;
  }
  private deleteImage() {
    if(this.imageIndex === this.images.length - 1) {
      this.imageIndex = this.imageIndex - 1;
      this.$emit("deleteClick", this.imageIndex + 1, this.tireIndex, this.isSummer)
    } else {
      this.$emit("deleteClick", this.imageIndex, this.tireIndex, this.isSummer)
    }
    
  }
}
